import { createHookStore, STORE_NAMES } from '@namespace/helpers-store';
import { TournamentsLeaderboardsState } from './types';

export const initialState: TournamentsLeaderboardsState = {
  tournamentsLeaderboards: {}
};

export const useTournamentsLeaderboardsStore =
  createHookStore<TournamentsLeaderboardsState>(
    STORE_NAMES.TOURNAMENTS_LEADERBOARDS_STORE,
    initialState
  );
